<template>
  <div v-if="list && list.length" class="storeMyOrder">
    <div class="myOrder">
      <div class="orderTable">
        <h3 class="myOrderTitle notranslate">
          {{ locale.order_list }}
          <button type="button" class="btnClose" @click.stop="close">{{ locale.close }}</button>
        </h3>
        <div class="orderTableHeader notranslate">
          <div class="name">{{ locale.order_product_name }}</div>
          <div class="quantity">{{ locale.quantity }}</div>
          <div class="price"><span></span>{{ locale.promotion_goods_amount }}</div>
          <div class="totalPrice">{{ locale.order_total }}</div>
        </div>
        <div class="orderTableBody">
          <div v-for="(item, index) in orderList"
            :key="index"
            class="row"
            :class="{isCancelItem: item.status === 'cancel' || item.status === 'fail'}">
            <div class="orderItem">
              <div class="name">
                <span v-if="item.status === 'cancel' || item.status === 'fail'" class="cancelItemStatus">{{ item.status === 'cancel' ? `(${locale.canceled})` : item.status === 'fail' ? `(${locale.failed})` : 'error' }}</span>
                {{ item.name[lang] }}
              </div>
              <div class="quantity notranslate">{{ item.quantity }}{{locale.unit_item}}</div>
              <div class="price notranslate">{{ priceFormat(item.itemPrice) }}</div>
              <div class="totalPrice notranslate">{{ item.options ? '' : priceFormat(item.totalPrice) }}</div>
            </div>
            <div v-if="item.options" class="optionInfo">
              <div v-for="(opt, idx) in item.options"
                :key="idx"
                :class="{subOptionItem: opt.parentOptionId}"
                class="orderItem orderOptionItem">
                <template v-if="opt.value">
                  <div class="name">
                    <p class="labelName">{{ opt.name ? opt.name[lang] : '' }}</p>
                    <p class="value">{{ opt.value }}</p>
                  </div>
                </template>
                <template v-else>
                  <div class="name">{{ opt.name[lang] }}</div>
                  <div class="quantity notranslate">{{ opt.quantity }}{{locale.unit_item}}</div>
                  <div class="price notranslate">{{ priceFormat(opt.optPrice) }}</div>
                  <div class="totalPrice"></div>
                </template>
              </div>
              <div class="orderItem notranslate">
                <div class="name"></div>
                <div class="quantity">{{ item.quantity }}{{locale.unit_item}}</div>
                <div class="price"><span>{{locale.price_include_option}}</span>{{ priceFormat(item.totalPrice) }}</div>
                <div class="totalPrice">{{ priceFormat(item.totalPrice) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="orderTableFooter notranslate">
        {{ locale.total }}
        <div class="totalPrice">{{ priceFormat(orderTotalPrice) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import OrderShopItem from '@/components/Mypage/OrderShopItem'

export default {
  name: 'shopMyOrder',
  props: [
    'locale',
    'lang',
    'responsive',
    'shopPageId'
  ],
  components: {
    OrderShopItem
  },
  computed: {
    isExcludeTax () {
      return this.$store.getters['shop/getShopSettings'](this.shopPageId).excludeTax || false
    },
    orderList () {
      const list = this.list || []
      return list
        // 1) ordersheet 평탄화
        .reduce((acc, item) => {
          const extracted = (item.ordersheet || [])
            .map(o => {
              if (!o || !o.itemOrderSheet) return null

              return {
                ...o.itemOrderSheet,
                isCallItem: o.isCallItem === true // 알림전용 아이템인가?
              }
            })
            .filter(Boolean)
          return acc.concat(extracted)
        }, [])
        // 2) 각 itemOrderSheet → 화면에서 쓰기 좋은 구조로 매핑
        .map(item => {
          if (!item) return null

          const mainItem = item.main && item.main[0]

          const base = {
            name: mainItem && mainItem.shopItemName,
            itemPrice: mainItem && mainItem.priceInfo
              ? Number(this.getItemPrice(mainItem.priceInfo))
              : 0,
            quantity: Number(item.quantity) || 0,
            totalPrice: item.totalPriceInfo && item.totalPriceInfo.totalPrice
              ? Number(item.totalPriceInfo.totalPrice)
              : 0,
            status: item.status,
            isCallItem: item.isCallItem === true
          }

          // 옵션이 없으면 여기서 반환
          if (!item.options || !item.options.length) {
            return base
          }

          console.log(item)

          // 3) 옵션 평탄화
          const flatOptions = this.flattenOptions(item.options)

          // 4) 부모-자식 순 정렬
          const sortedOptions = this.sortOptionsByParent(flatOptions)

          return {
            ...base,
            options: sortedOptions
          }
        })
        .filter(item => item && !item.isCallItem)
    },
    orderTotalPrice () {
      const list = this.orderList.filter(item => item.status !== 'cancel' && item.status !== 'fail')
      return list.reduce((sum, item) => sum + (item.totalPrice || 0), 0)
    }
  },
  created () {
  },
  async mounted () {
    await this.getKey()
    await this.getOrderHistory()
  },
  data () {
    return {
      list: [],
      moreCount: 0,
      next: null
    }
  },
  methods: {
    getItemPrice (priceInfo, price) {
      const excludeTax = this.isExcludeTax
      return priceInfo && (excludeTax ? (priceInfo.net || priceInfo.gross) : priceInfo.gross) || price
    },
    // 옵션 평탄화
    flattenOptions (options = []) {
      return options.reduce((acc, optGroup) => {
        const groupParentId = optGroup.parentOption
        const groupParentItemId = optGroup.parentOptionItem

        const extracted = (optGroup.selectOptItem || []).map(opt => ({
          ...optGroup.optType === 'input'
          ? {
            name: optGroup.optName,
            value: opt.value
          }
          : {
            optionItemId: opt.optionItemId,
            name: opt.name || null,
            optPrice: opt.priceInfo
              ? Number(this.getItemPrice(opt.priceInfo))
              : 0,
            quantity: Number(opt.quantity) || 1
          },
          ...(groupParentItemId && {
            parentOptionId: groupParentId,        // 묶음의 부모 그룹 id
            parentOptionItemId: groupParentItemId // 실제 부모 옵션 아이템 id
          }),
          ...opt.value && {
            value: opt.value
          }
        }))

        return acc.concat(extracted)
      }, [])
    },

    // 부모-자식 순 정렬
    sortOptionsByParent (options = []) {
      if (!Array.isArray(options)) return []

      const parents = []
      const childrenMap = new Map()

      // 1) 부모 / 자식 분리
      options.forEach(opt => {
        const parentKey = opt.parentOptionItemId
        if (parentKey) {
          if (!childrenMap.has(parentKey)) childrenMap.set(parentKey, [])
          childrenMap.get(parentKey).push(opt)
        } else {
          // parentOptionItemId 없으면 "최상위 옵션"으로 취급
          parents.push(opt)
        }
      })

      const ordered = []

      // 2) 부모 순서를 기준으로, 바로 뒤에 자식들 붙이기
      parents.forEach(parent => {
        ordered.push(parent)

        const kids = childrenMap.get(parent.optionItemId)
        if (kids && kids.length) {
          ordered.push(...kids)
          childrenMap.delete(parent.optionItemId)
        }
      })

      // 3) 부모를 못 찾은 자식들(데이터 오류/비정상)도 마지막에 붙여주기
      childrenMap.forEach(kids => {
        ordered.push(...kids)
      })

      return ordered
    },
    mainItemInfo (item) {
      const lang = this.lang
      const mainItem = item.main[0]
      return mainItem && {
        name: mainItem.shopItemName[lang],
        price: Number(this.getItemPrice(mainItem.priceInfo))
      }
    },
    priceFormat (price) {
      const currency = this.$store.getters['shop/getShopCurrency'] || null
      return this.$store.getters['util/getPriceFormatter'](price, currency, true)
    },
    async getOrderHistory () {
      this.$store.commit('loading', true)
      const next = this.next
      const data = {
        mypageType: 'order',
        paging: {
          limit: 30,
          ...next && {
            next: next
          }
        }
      }
      const history = await this.$store.dispatch('guest/getMypageHistory', data)
      if (history && history.items) {
        if (history.items.length) {
          this.list = this.list.map(x => {
            return {
              ...x,
              firstItem: false
            }
          }).concat(history.items.filter(x => {
              return x.order_submit_type && x.order_submit_type === 'SHOP_ITEM_TYPE'
            }).map((x, i) => {
              return {
                ...x,
                firstItem: i === 0, // 새로 불러온 첫 아이템으로 스크롤 하기 위한 flag
                ordersheet: x.ordersheet.map(content => {
                  return {
                    ...content,
                    itemOrderSheet: {
                      ...content.itemOrderSheet,
                      status: content.status
                    }
                  }
                }),
              }
            })
          )
        } else {
          this.$emit('setToastMessage', this.locale.nodata_order_history)
          this.close()
        }
      } else {
        this.$emit('setToastMessage', this.locale.nodata_order_history)
        this.close()
      }
      this.$store.commit('loading', false)
      this.next = (history && history.next) || null
      this.scrollList()
      return history
    },
    async getKey () {
      if (this.isPublic) {
        await this.$store.dispatch('authentication/getOtaKey')
      }
    },
    scrollList () {
      this.$nextTick(() => {
        const list = this.$refs.mypageList
        const firstItem = document.querySelector('.firstItem')
        if (firstItem && this.moreCount > 0) {
          const top = firstItem.offsetTop
          const height = firstItem.offsetHeight
          window.scrollTo({
            top: top,
            behavior: 'smooth'
          })
        }
        this.moreCount += 1
      })
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>